module.exports = __webpack_public_path__ + "img/page.0703e785.svg";